<coa-select-client-skeleton
  *ngIf="isLoading$ | async"
  class="client-list-skeleton"
></coa-select-client-skeleton>

<div
  [matMenuTriggerFor]="menu"
  class="select-client"
  mat-ripple
>
  <ng-container *ngIf="(isLoading$ | async) === false && selectedClientId">
    <span class="select-client__name">
      <span class="select-client__name-prefix">{{ 'Client' | translate}}:</span>
      <span
        class="select-client__name-value">{{ (clientsResponseError$ | async) ? ('Name unavailable' | translate) : (selectedClientId | clientName:(clientsResponse$ | async)) }}</span>
    </span>
    <span class="material-icons select-client__icon">{{ isMenuOpened ? 'expand_less' : 'expand_more'}}</span>
  </ng-container>
</div>


<mat-menu
  #menu="matMenu"
  class="select-client__menu">
  <ng-container *ngIf="(isLoading$ | async) === false && selectedClientId">
    <div
      *ngIf="(clientsResponseError$ | async )"
      class="select-client__menu-error"
    >{{ 'List of clients is currently unavailable. Please try again later' | translate }}</div>

    <ng-container *ngIf="(clientsResponseError$ | async ) === false">
      <div
        (click)="onSelectClient(clientId)"
        *ngFor="let clientId of (clientIds$ | async) | filterUserClients : (clientsResponse$ | async)"
        [ngClass]="{'select-client__menu-item--selected': clientId === selectedClientId}"
        class="select-client__menu-item"
        mat-menu-item>
        <mat-icon class="select-client__menu-icon">done</mat-icon>
        <span class="select-client__menu-item-value">{{ clientId | clientName:(clientsResponse$ | async) }}</span>
      </div>
    </ng-container>
  </ng-container>

</mat-menu>
